import React from 'react';
import { Link } from 'react-router-dom';
import { Hx8Logo } from './Navigation';

const cols = [
  { title: 'Platform', links: [{ label: 'Features', href: '#features' }, { label: 'How It Works', href: '#how-it-works' }, { label: 'Pricing', href: '#pricing' }, { label: 'Security', href: '#' }] },
  { title: 'Talent', links: [{ label: 'AI Specialists', href: '/talent' }, { label: 'Content', href: '/talent' }, { label: 'Video', href: '/talent' }, { label: 'Automation', href: '/talent' }, { label: 'SEO', href: '/talent' }] },
  { title: 'Company', links: [{ label: 'Blog', href: '#' }, { label: 'Careers', href: '#' }, { label: 'Privacy Policy', href: '/privacy', isRoute: true }, { label: 'Terms of Service', href: '/terms', isRoute: true }] },
];

const Footer = ({ variant = 'home' }) => {
  return (
    <footer style={{ borderTop: '1px solid rgba(240,236,228,0.07)', padding: '64px 48px 40px', background: '#080807' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        {/* CTA Strip */}
        <div style={{
          padding: '64px 48px', marginBottom: 64,
          position: 'relative', overflow: 'hidden', textAlign: 'center',
          background: '#0c0b09',
          border: '1px solid rgba(240,236,228,0.07)',
        }}>
          <div style={{
            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%,-50%)',
            width: 600, height: 600,
            background: 'radial-gradient(circle, rgba(232,112,26,0.1) 0%, transparent 65%)',
            pointerEvents: 'none',
          }} />
          <div style={{ position: 'relative', maxWidth: 600, margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 28 }}>
              <Hx8Logo size={56} />
            </div>
            <h2 style={{
              fontSize: 'clamp(32px, 4vw, 56px)', fontWeight: 700,
              letterSpacing: '-0.035em', lineHeight: 1.05, marginBottom: 16,
              color: '#f0ece4', fontFamily: "'Space Grotesk', sans-serif",
            }}>Ready to grow?</h2>
            <p style={{ fontSize: 17, color: 'rgba(240,236,228,0.45)', lineHeight: 1.75, marginBottom: 36, maxWidth: 420, margin: '0 auto 36px' }}>
              Build a single role or a full team of eight. Accept our match or interview candidates — zero agency fees, always.
            </p>
            <div style={{ display: 'flex', gap: 16, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 36 }}>
              <a href="https://vibe.hirex8.com/register?type=client" target="_blank" rel="noopener noreferrer"
                style={{
                  background: '#e8701a', color: '#0a0804', borderRadius: 0,
                  padding: '18px 40px', fontSize: 15, fontWeight: 700, letterSpacing: '0.07em',
                  textTransform: 'uppercase', cursor: 'pointer', textDecoration: 'none',
                  fontFamily: "'Space Grotesk', sans-serif", display: 'inline-block',
                  clipPath: 'polygon(0 0,calc(100% - 12px) 0,100% 12px,100% 100%,12px 100%,0 calc(100% - 12px))',
                  boxShadow: '0 0 18px rgba(232,112,26,0.3)', transition: 'all 0.2s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#f07d2e'; e.currentTarget.style.boxShadow = '0 0 32px rgba(232,112,26,0.55)'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#e8701a'; e.currentTarget.style.boxShadow = '0 0 18px rgba(232,112,26,0.3)'; }}
              >Build Your Team →</a>
              <a href="https://cal.com/matching-expert/30min" target="_blank" rel="noopener noreferrer"
                style={{
                  background: 'transparent', color: '#f0ece4',
                  border: '1px solid rgba(240,236,228,0.12)',
                  borderRadius: 0, padding: '18px 40px',
                  fontSize: 15, fontWeight: 600, letterSpacing: '0.04em',
                  textDecoration: 'none', display: 'inline-block', transition: 'all 0.2s',
                  fontFamily: "'Space Grotesk', sans-serif",
                }}
                onMouseEnter={e => { e.currentTarget.style.color = '#e8701a'; e.currentTarget.style.borderColor = '#e8701a'; }}
                onMouseLeave={e => { e.currentTarget.style.color = '#f0ece4'; e.currentTarget.style.borderColor = 'rgba(240,236,228,0.12)'; }}
              >Talk to Sales</a>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: 36, flexWrap: 'wrap' }}>
              {['Zero agency fees', 'No contracts', '48hr deployment', 'Human support'].map(l => (
                <div key={l} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><polyline points="1.5,6 4.5,9 10.5,3" stroke="#e8701a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  <span style={{ fontSize: 13, color: 'rgba(240,236,228,0.4)' }}>{l}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer columns */}
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: 64, marginBottom: 48 }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
              <Hx8Logo size={36} />
              <span style={{ fontSize: 18, fontWeight: 700, letterSpacing: '-0.02em', color: '#f0ece4', fontFamily: "'Space Grotesk', sans-serif" }}>Hirex8</span>
            </div>
            <p style={{ fontSize: 14, color: 'rgba(240,236,228,0.35)', lineHeight: 1.75, maxWidth: 280 }}>
              Human-led, AI-accelerated growth for forward-thinking agencies and brands.
            </p>
          </div>
          {cols.map(c => (
            <div key={c.title}>
              <div style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#e8701a', marginBottom: 20 }}>{c.title}</div>
              {c.links.map(l => (
                l.isRoute ? (
                  <Link key={l.label} to={l.href} style={{ display: 'block', fontSize: 14, color: 'rgba(240,236,228,0.4)', textDecoration: 'none', marginBottom: 10, transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color = '#f0ece4'}
                    onMouseLeave={e => e.target.style.color = 'rgba(240,236,228,0.4)'}
                  >{l.label}</Link>
                ) : (
                  <a key={l.label} href={l.href} style={{ display: 'block', fontSize: 14, color: 'rgba(240,236,228,0.4)', textDecoration: 'none', marginBottom: 10, transition: 'color 0.2s' }}
                    onMouseEnter={e => e.target.style.color = '#f0ece4'}
                    onMouseLeave={e => e.target.style.color = 'rgba(240,236,228,0.4)'}
                  >{l.label}</a>
                )
              ))}
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div style={{ borderTop: '1px solid rgba(240,236,228,0.07)', paddingTop: 28, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
          <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, color: 'rgba(240,236,228,0.25)', letterSpacing: '0.06em' }}>
            © {new Date().getFullYear()} Hirex8 · All rights reserved
          </span>
          <div style={{ display: 'flex', gap: 24 }}>
            <Link to="/privacy" style={{ fontSize: 12, color: 'rgba(240,236,228,0.25)', textDecoration: 'none' }}>Privacy</Link>
            <Link to="/terms" style={{ fontSize: 12, color: 'rgba(240,236,228,0.25)', textDecoration: 'none' }}>Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
